
import withRoot from "../withRoot";
import { useManufacturer } from "../contexts/WithManufacturer";
import React from "react";
import {
  PartnerRelationshipPage as PartnerRelationshipPageContent
} from "randmarcomps";
import { useParams } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import RmPageHeader from "../components/layout/RmPageHeader";
import { RmBodyZone } from "randmarcomps";

const PartnerRelationshipPage: React.FC = () => {
  const { applicationId } = useManufacturer();
  const { partnerId } = useParams<{ partnerId: string }>();
  const { user, isSuperAdmin } = useUser();
  const userEmail = user?.profile?.email ?? "";

  return (
    <>
      <RmPageHeader
        title="Partner Relationship"
        subtitle="Review and manage relationship details for the selected partner."
      />
      <RmBodyZone className="space-y-6 pb-10">
        <main className="w-full">
          <PartnerRelationshipPageContent
              applicationId={applicationId}
              partnerId={partnerId ?? ""}
              userEmail={userEmail}
              isSuperAdmin={isSuperAdmin}
              shopifyHostName={undefined}
          />
        </main>
      </RmBodyZone>
    </>
  );
};

export default withRoot(PartnerRelationshipPage);
